var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0441 9.32353H14.7059V1.97059C14.7059 1.16176 14.0441 0.5 13.2353 0.5H7.35294C6.54412 0.5 5.88235 1.16176 5.88235 1.97059V9.32353H3.54412C2.23529 9.32353 1.57353 10.9118 2.5 11.8382L9.25 18.5882C9.82353 19.1618 10.75 19.1618 11.3235 18.5882L18.0735 11.8382C19 10.9118 18.3529 9.32353 17.0441 9.32353ZM0 24.0294C0 24.8382 0.661765 25.5 1.47059 25.5H19.1176C19.9265 25.5 20.5882 24.8382 20.5882 24.0294C20.5882 23.2206 19.9265 22.5588 19.1176 22.5588H1.47059C0.661765 22.5588 0 23.2206 0 24.0294Z",
    fill: "#796DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f2655a5e44ad96fd0129a8466e582d43.svg";
export { ForwardRef as ReactComponent };